import React from 'react'

import System from '../components/SystemContent'

const SystemPage = props => <System {...props} />

export default SystemPage
